import React, { useId } from "react";
import ToolbarItem from "./ToolbarItem";
import { useEditorContext } from "../Wysiwyg";

const ToolbarPlaceholderRow = ({ icon, items }) => {
  const { editor } = useEditorContext();
  const id = useId();

  return (
    <div
      className="d-flex tiptap-toolbar align-items-center border border-bottom-0"
      style={{ padding: "5px 15px", gap: "8px" }}
    >
      {icon}
      <div className="d-flex items-center flex-wrap" style={{ gap: "2px 8px" }}>
        {items.map((item, idx) => (
          <ToolbarItem
            key={`toolbar-placeholder-item-${id}-${idx}`}
            id={`toolbar-placeholder-item-${id.replace(/\:/g, "")}-${idx}`}
            tooltip={item.code}
            active={false}
            onToggle={() =>
              editor.chain().focus().insertContent(item.code).run()
            }
            icon={<span>{item.caption}</span>}
          />
        ))}
      </div>
    </div>
  );
};

export default ToolbarPlaceholderRow;
